import { useState, useEffect, MutableRefObject } from 'react';

export const useTooltipForLongName = (
  parentElementRef: MutableRefObject<HTMLDivElement | HTMLSpanElement>,
  childElementRef: MutableRefObject<HTMLDivElement | HTMLSpanElement>
): boolean => {
  const [isTooltip, setTooltip] = useState(false);

  useEffect(() => {
    const { current: parentElement } = parentElementRef;
    const { current: childElement } = childElementRef;

    if (!parentElement || !childElement) return;

    const isTooltipShown =
      childElement.offsetWidth > parentElement.offsetWidth || childElement.scrollWidth > parentElement.offsetWidth;

    if (isTooltipShown) setTooltip(true);
  }, []);

  return isTooltip;
};
